import { ApiProperty } from "@nestjs/swagger";

export class ZoneRackLevelByIdDto{
    @ApiProperty()
    rackId:number;
    zoneId:number;
    levelId:number;
}